import { ComparisonRow } from "../components/ComparisonRow";
import { SectionHead } from "../components/SectionHead";
import { comparisons } from "../content/comparisons";
import { copy } from "../content/copy";

export function VisionSection() {
  return (
    <section className="section vision" id="vision">
      <div className="container">
        <SectionHead
          eyebrow={copy.vision.eyebrow}
          title={
            <>
              Candidates work in the interview the <span className="serif-italic">same way</span>{" "}
              they'd work on day one.
            </>
          }
          lede={copy.vision.lede}
        />
        <div className="vision-grid">
          {comparisons.map((c) => (
            <ComparisonRow key={c.domain} comparison={c} />
          ))}
        </div>
      </div>
    </section>
  );
}
